/**
 * 菜单与权限集中配置文件
 * 
 * 【维护说明】新增/修改菜单或权限时，只需修改本文件，Menu.vue 和 SetAuthorize.vue 自动同步。
 *
 * 字段说明：
 *   title      - 显示名称
 *   path       - Tab 页标识（对应 store.commit("openMenu") 的 path，也用于自动注册组件名 c_xxx）
 *   permission - 权限标识（SetAuthorize 中的 TableName，菜单检查时自动加 M_ 前缀）
 *   btnArr     - 按钮权限（可选，生成 B_xxx_按钮 权限）
 *   dataArr    - 数据范围权限（可选，生成 D_xxx_范围 权限）
 *   icon       - Element Plus 图标组件名（仅菜单组需要）
 *   index      - 菜单组索引（仅菜单组需要）
 *   permissions - 父菜单可见性权限数组（任一匹配即显示，仅菜单组需要）
 *   children   - 子菜单项数组
 */

// ===== 菜单树配置 =====
export const menuTree = [
  // ── 商品管理 ──
  {
    title: '商品管理', icon: 'GoodsFilled', index: '1',
    permissions: ['M_ShangPin_List'],
    children: [
      { title: '旅游商品', path: 'ShangPinList', permission: 'ShangPin_List', btnArr: ['添加', '管理', '编辑', '删除', '分享码'], dataArr: ['全部', '部门', '部门及下级部门', '个人'] },
      { title: '酒店管理', path: 'JiuDianList', permission: 'JiuDian_List', btnArr: ['添加', '管理', '编辑', '删除'], dataArr: ['全部', '部门', '部门及下级部门', '个人'] },
      { title: '门票管理', path: 'MenPiaoList', permission: 'MenPiao_List', btnArr: ['添加', '管理', '编辑', '删除'], dataArr: ['全部', '部门', '部门及下级部门', '个人'] },
      { title: '组合商品', path: 'ZuHeChanPinList', permission: 'ZuHeChanPin_List', btnArr: ['添加', '管理', '编辑', '删除'], dataArr: ['全部', '部门', '部门及下级部门', '个人'] },
      { title: '美食管理', path: 'MeiShiList', permission: 'MeiShi_List', btnArr: ['添加', '管理', '编辑', '删除'], dataArr: ['全部', '部门', '部门及下级部门', '个人'] },
      { title: '优惠券管理', path: 'YouHuiQuanList', permission: 'YouHuiQuan_List', btnArr: ['添加', '编辑', '删除', '管理'], dataArr: ['全部', '部门', '部门及下级部门', '个人'] },
      { title: '优惠券统计', path: 'YouHuiQuanStats', permission: 'YouHuiQuan_Stats' },
    ],
  },
  // ── 订单管理 ──
  {
    title: '订单管理', icon: 'List', index: '2',
    permissions: ['M_ShangPinDingDan_Add', 'M_ShangPinDingDan_List', 'M_ShangPinDingDanBianGengJiLu_List', 'M_LvYouDingDan_List'],
    children: [
      { title: '创建订单', path: 'ShangPinDingDanXdList', permission: 'ShangPinDingDan_Add' },
      { title: '商品订单', path: 'ShangPinDingDanList', permission: 'ShangPinDingDan_List', btnArr: ['管理'], dataArr: ['全部', '部门', '部门及下级部门', '个人'] },
      { title: '变更记录', path: 'ShangPinDingDanBianGengJiLuList', permission: 'ShangPinDingDanBianGengJiLu_List', btnArr: ['审核'], dataArr: ['全部', '部门', '部门及下级部门', '个人'] },
      { title: '旅游下单', path: 'LvYouDingDanAdd', permission: 'LvYouDingDan_Add' },
      { title: '旅游订单', path: 'LvYouDingDanList', permission: 'LvYouDingDan_List', btnArr: ['添加', '管理'], dataArr: ['全部', '部门', '部门及下级部门', '个人'] },
    ],
  },
  // ── 客户管理 ──
  {
    title: '客户管理', icon: 'PhoneFilled', index: '3',
    permissions: ['M_KeHu_GeRen', 'M_KeHu_DanWei', 'M_KeHu_TongHang', 'M_YouKe_List', 'M_YouKe_Hmd', 'M_DaoZhangGongShi_RenLing'],
    children: [
      { title: '个人客户', path: 'KeHuGeRenList', permission: 'KeHu_GeRen', btnArr: ['添加', '管理', '编辑', '删除'], dataArr: ['全部', '部门', '部门及下级部门', '个人'] },
      { title: '单位客户', path: 'KeHuDanWeiList', permission: 'KeHu_DanWei', btnArr: ['添加', '管理', '编辑', '删除'], dataArr: ['全部', '部门', '部门及下级部门', '个人'] },
      { title: '同行客户', path: 'KeHuTongHangList', permission: 'KeHu_TongHang', btnArr: ['添加', '管理', '编辑', '删除'], dataArr: ['全部', '部门', '部门及下级部门', '个人'] },
      { title: '旅客', path: 'YouKeList', permission: 'YouKe_List', btnArr: ['添加', '编辑', '删除', '拉黑'], dataArr: ['全部', '部门', '部门及下级部门', '个人'] },
      { title: '黑名单管理', path: 'YouKeHmdList', permission: 'YouKe_Hmd', btnArr: ['编辑', '删除', '移除'], dataArr: ['全部', '部门', '部门及下级部门', '个人'] },
      { title: '到账认领', path: 'DaoZhangGongShiRlList', permission: 'DaoZhangGongShi_RenLing', btnArr: ['认领'], dataArr: ['全部', '部门', '部门及下级部门', '个人'] },
    ],
  },
  // ── 供应链 ──
  {
    title: '供应链', icon: 'Stamp', index: '5',
    permissions: ['M_GongYingShang_List', 'M_ShangPinDingDan_Dz', 'M_LvYouDingDan_Dz'],
    children: [
      { title: '供应商管理', path: 'GongYingShangList', permission: 'GongYingShang_List', btnArr: ['添加', '管理', '编辑', '删除'], dataArr: ['全部', '部门', '部门及下级部门', '个人'] },
      { title: '商品对账', path: 'DuiZhangDanSpddList', permission: 'ShangPinDingDan_Dz', dataArr: ['全部', '部门', '部门及下级部门', '个人'] },
      { title: '对账审核', path: 'DuiZhangDanList', permission: 'DuiZhangDan_ShenHe', dataArr: ['全部', '部门', '部门及下级部门', '个人'] },
      { title: '采购付款', path: 'DuiZhangDanLycgList', permission: 'LvYouDingDan_Dz', dataArr: ['全部', '部门', '部门及下级部门', '个人'] },
    ],
  },
  // ── 导游管理 ──
  {
    title: '导游管理', icon: 'Share', index: '6',
    permissions: ['M_DaoYou_List', 'M_DaoYou_BuZhu'],
    children: [
      { title: '导游档案', path: 'DaoYouList', permission: 'DaoYou_List', btnArr: ['添加', '编辑', '删除'], dataArr: ['全部', '部门', '部门及下级部门', '个人'] },
      { title: '导游补助', path: 'DaoYouBuZhuDypq', permission: 'DaoYou_BuZhu', dataArr: ['全部', '部门', '部门及下级部门', '个人'] },
    ],
  },
  // ── 财务操作 ──
  {
    title: '财务操作', icon: 'Histogram', index: '7',
    permissions: [
      'M_CaiWu_Dashboard', 'M_CaiWu_ShouKuan', 'M_CaiWu_LiRun', 'M_CaiWu_YingFu',
      'M_DuiZhangDan_Fk', 'M_LvYouDingDan_Jhk', 'M_LvYouDingDan_Tk',
      'M_DaoYouBuZhu_Sh', 'M_LvYouDingDan_Ft', 'M_LvYouDingDanFaTuanJiLu_Sh',
      'M_LvYouDingDan_Js', 'M_DaoZhangGongShi_List', 'M_LvYouDingDan_Ck',
      'M_CaiWu_SpddMingXi', 'M_CaiWu_FenXiaoFanYong',
    ],
    children: [
      { title: '财务总览', path: 'CaiWuDashboard', permission: 'CaiWu_Dashboard' },
      { title: '收款管理', path: 'CaiWuShouKuan', permission: 'CaiWu_ShouKuan' },
      { title: '成本与利润', path: 'CaiWuChengBenLiRun', permission: 'CaiWu_LiRun' },
      {
        title: '应付账款', index: '7-1',
        permissions: ['M_CaiWu_YingFu', 'M_DuiZhangDan_Fk'],
        children: [
          { title: '应付账款', path: 'CaiWuYingFu', permission: 'CaiWu_YingFu' },
          { title: '对账付款', path: 'DuiZhangDanFkList', permission: 'DuiZhangDan_Fk', dataArr: ['全部', '部门', '部门及下级部门', '个人'] },
        ],
      },
      { title: '导游借还款', path: 'LvYouDingDanJhk', permission: 'LvYouDingDan_Jhk', dataArr: ['全部', '部门', '部门及下级部门', '个人'] },
      { title: '订单退款', path: 'LvYouDingDanTuiKuanList', permission: 'LvYouDingDan_Tk' },
      { title: '导补发放管理', path: 'DaoYouBuZhuList', permission: 'DaoYouBuZhu_Sh', dataArr: ['全部', '部门', '部门及下级部门', '个人'] },
      { title: '发团审核', path: 'LvYouDingDanFaTuanJiLuList', permission: 'LvYouDingDanFaTuanJiLu_Sh', dataArr: ['全部', '部门', '部门及下级部门', '个人'] },
      { title: '结算审核', path: 'LvYouDingDanJieSuanList', permission: 'LvYouDingDan_Js', dataArr: ['全部', '部门', '部门及下级部门', '个人'] },
      { title: '到账公示', path: 'DaoZhangGongShiList', permission: 'DaoZhangGongShi_List', btnArr: ['添加', '撤回', '删除'], dataArr: ['全部', '部门', '部门及下级部门', '个人'] },
      { title: '旅游订单明细', path: 'LvYouDingDanSearchList', permission: 'LvYouDingDan_Ck', dataArr: ['全部', '部门', '部门及下级部门', '个人'] },
      { title: '商品订单明细', path: 'CaiWuSpddMingXi', permission: 'CaiWu_SpddMingXi', dataArr: ['全部', '部门', '部门及下级部门', '个人'] },
      { title: '分销返佣', path: 'CaiWuFenXiaoFanYong', permission: 'CaiWu_FenXiaoFanYong', dataArr: ['全部', '部门', '部门及下级部门', '个人'] },
    ],
  },
  // ── 发票管理 ──
  {
    title: '发票管理', icon: 'Tickets', index: '12',
    permissions: ['M_FaPiaoTouTai_List', 'M_FaPiaoKaiPiao_List'],
    children: [
      { title: '发票抬头管理', path: 'FaPiaoList', permission: 'FaPiaoTouTai_List', btnArr: ['添加', '编辑', '删除'] },
      { title: '开票管理', path: 'FaPiaoKaipiao', permission: 'FaPiaoKaiPiao_List' },
    ],
  },
  // ── 业务查询 ──
  {
    title: '业务查询', icon: 'Comment', index: '8',
    permissions: ['M_TongYeXiaoShouTongJi_List'],
    children: [
      { title: '同业销售统计', path: 'BaoBiaoXstj', permission: 'XiaoShouTongJi_List' },
    ],
  },
  // ── 行政管理 ──
  {
    title: '行政管理', icon: 'Menu', index: '10',
    permissions: ['M_GongGao_List'],
    children: [
      { title: '通知公告', path: 'GongGaoList', permission: 'GongGao_List', btnArr: ['添加', '编辑', '删除'], dataArr: ['全部', '部门', '部门及下级部门', '个人'] },
    ],
  },
  // ── 系统管理 ──
  {
    title: '系统管理', icon: 'Tools', index: '11',
    permissions: ['M_YongHu_List', 'M_BuMen_List', 'M_JueSe_List', 'M_ZiDian_List', 'M_YouKe_Xcx'],
    children: [
      { title: '部门管理', path: 'BuMenList', permission: 'BuMen_List', btnArr: ['添加', '编辑', '删除'], dataArr: ['全部', '部门', '部门及下级部门', '个人'] },
      { title: '角色管理', path: 'JueSeList', permission: 'JueSe_List', btnArr: ['添加', '授权', '绑定用户', '编辑', '删除'], dataArr: ['全部', '部门', '部门及下级部门', '个人'] },
      { title: '用户管理', path: 'YongHuList', permission: 'YongHu_List', btnArr: ['添加', '编辑', '重置密码', '删除'], dataArr: ['全部', '部门', '部门及下级部门', '个人'] },
      { title: '小程序用户', path: 'YouKeXcxList', permission: 'YouKe_Xcx' },
      { title: '基础数据', path: 'ZiDianList', permission: 'ZiDian_List', btnArr: ['添加', '编辑', '删除'], dataArr: ['全部', '部门', '部门及下级部门', '个人'] },
      { title: '对公账户', path: 'ZhangHuList', permission: 'ZhangHu_List', btnArr: ['添加', '编辑', '删除'], dataArr: ['全部', '部门', '部门及下级部门', '个人'] },
      { title: '短信模板', path: 'SmsList', permission: 'Sms_List', btnArr: ['添加', '编辑', '删除'] },
      {
        title: '小程序管理', icon: 'Tools', index: '11-7',
        permissions: ['M_WeiXinMini_Config'],
        children: [
          { title: '首页轮播', path: 'HomeLunBoList' },
          { title: '首页分类', path: 'HomeFenLeiList' },
        ],
      },
      { title: '评价管理', path: 'ShangPinPingJiaList', permission: 'ShangPinPingJia_List'  },
      { title: '游客问询', path: 'YouKeZiXunList', permission: 'YouKeZiXun_List' },
    ],
  },
]

// ===== 独立权限项（仅在权限配置中显示，无对应菜单项）=====
// 注意：已在 menuTree 中定义的权限不要重复添加
export const extraAuthItems = [
  { title: '到账认领', permission: 'DaoZhangGongShi_Rl', btnArr: ['认领'], dataArr: ['全部', '部门', '部门及下级部门', '个人'] },
  { title: '对账付款', permission: 'DuiZhangDan_Fk', dataArr: ['全部', '部门', '部门及下级部门', '个人'] },
  { title: '导游借款', permission: 'LvYouDingDan_Jhk', dataArr: ['全部', '部门', '部门及下级部门', '个人'] },
  { title: '订单退款审核', permission: 'LvYouDingDan_Tk' },
  { title: '导补发放审核', permission: 'DaoYouBuZhu_Sh', dataArr: ['全部', '部门', '部门及下级部门', '个人'] },
  { title: '发团审核', permission: 'LvYouDingDanFaTuanJiLu_Sh', dataArr: ['全部', '部门', '部门及下级部门', '个人'] },
  { title: '结算审核', permission: 'LvYouDingDan_Js', dataArr: ['全部', '部门', '部门及下级部门', '个人'] },
  { title: '同业销售统计', permission: 'XiaoShouTongJi_List' },
  { title: '小程序管理', permission: 'WeiXinMini_Config' },
]
